export interface UnshareArtifactPositionsRequest {
  publicId: string
  positionIds: string[]
}
